var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-77",
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#000",
  fillOpacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fill: "#FFF",
  d: "M22 25a3 3 0 1 0 6 0 3 3 0 0 0-6 0m9.16-5.812c-.363 0-1.551-2.583-1.551-2.583S29.103 16 28.74 16h-7.48c-.363 0-.754.272-.869.605s-1.188 2.582-1.551 2.582H16.2c-1.21 0-2.2.957-2.2 2.125v9.563c0 1.169.99 2.125 2.2 2.125h17.6c1.21 0 2.2-.956 2.2-2.125v-9.562c0-1.17-.99-2.125-2.2-2.125zM20 25a5 5 0 1 1 10 0 5 5 0 0 1-10 0m12-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
  opacity: 0.9
})))));
export default SvgPhoto;